export var HoldingErrorEnum;
(function (HoldingErrorEnum) {
    HoldingErrorEnum["ERROR_DATA"] = "errorData";
    HoldingErrorEnum["DOWNLOADSTATUS"] = "downloadStatus";
    HoldingErrorEnum["EMAILSTATUS"] = "emailStatus";
    HoldingErrorEnum["DP_TRANSACTION_ERROR_DATA"] = "dpTransactionHistoryErrorData";
    HoldingErrorEnum["DP_TRANSACTION_SUBMIT_ERROR_DATA"] = "dpTransactionSubmitErrorData";
})(HoldingErrorEnum || (HoldingErrorEnum = {}));
export var EmptyIcon;
(function (EmptyIcon) {
    EmptyIcon["EMPTY"] = "empty";
    EmptyIcon["SEARCH"] = "search";
    EmptyIcon["FILTER"] = "filter";
    EmptyIcon["ERROR"] = "error";
    EmptyIcon["SEARCH_NEW"] = "search_new";
    EmptyIcon["ERROR_EXCLA"] = "error_exla";
})(EmptyIcon || (EmptyIcon = {}));
export var StockDetailsEnum;
(function (StockDetailsEnum) {
    StockDetailsEnum["OVERVIEW"] = "overview";
    StockDetailsEnum["TRANSACTION"] = "transaction";
})(StockDetailsEnum || (StockDetailsEnum = {}));
